import { Helmet } from 'react-helmet-async';

const SEOHead = ({ 
    title = "Prasoon Soni | Software Engineer & Full Stack Developer",
    description = "Portfolio of Prasoon Soni - A passionate software engineer and full stack developer dedicated to solving problems and making a difference through technology.",
    path = "/",
    type = "website"
}) => {
    const siteUrl = "https://prasoonsoni.in";
    const fullUrl = `${siteUrl}${path}`;
    const imageUrl = `${siteUrl}/profile.png`;

    return (
        <Helmet>
            {/* Primary Meta Tags */}
            <title>{title}</title>
            <meta name="title" content={title} />
            <meta name="description" content={description} />
            <link rel="canonical" href={fullUrl} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={type} />
            <meta property="og:url" content={fullUrl} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={imageUrl} />

            {/* Twitter */}
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content={fullUrl} />
            <meta property="twitter:title" content={title} />
            <meta property="twitter:description" content={description} />
            <meta property="twitter:image" content={imageUrl} />
        </Helmet>
    );
};

export default SEOHead;
